import axios from "axios";
import Cookie from "js-cookie";
import urls from "./url";
import { getAccessToken, clearTokens } from "./tokenStorage";

export function clearLocalAuthState() {
  clearTokens();
  Cookie.remove("data", { path: "/" });
  Cookie.remove("hospital_detail", { path: "/" });
  window.localStorage.removeItem("username");
  window.sessionStorage.clear();
}

export async function performLogout(navigate) {
  const accessToken = getAccessToken();

  try {
    await axios.post(
      `${urls.DEV_URL}nurse/logout/`,
      { subscriber_id: window.localStorage.getItem("onesignalId") },
      {
        headers: {
          "Request-ID": "allow|me",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  } catch (error) {
    console.log("Logout failed", error);
  } finally {
    clearLocalAuthState();
    navigate("/");
  }
}
